import React, { forwardRef, useImperativeHandle, useState } from 'react';
import Column from 'src/components/10-atoms/layout/Column';
import { bottomDrawerHelperActions } from 'src/components/20-helper-views/bottom-drawer/useBottomDrawer';
import useFTUE from 'src/lib/ftue/hooks/useFTUE';
import FTUEKeys from 'src/lib/ftue/keys';
import QuillEditor from '../QuillEditor';
import isEmpty from '../QuillEditor/utils/isEmpty';
import Toolbar from '../Toolbar';
import useChangeHandler from './handlers/useChangeHandler';
import useFocusHandler from './handlers/useFocusHandler';
import Img2TxtIntroDrawer from './Img2TxtIntroDrawer';
const HTMLEditor = forwardRef(({ initialValue, initialDelta, placeholder, gutterBottom, onChange, onFocus, onBlur, ...columnProps }, ref) => {
    const [quillRef, setQuillRef] = useState();
    useFocusHandler(quillRef, {
        onBlur,
        onFocus,
    });
    useChangeHandler(quillRef, { onChange });
    useImperativeHandle(ref, () => ({
        getContents: () => quillRef?.getContents(),
        getHTML: () => quillRef?.getSemanticHTML(),
        getText: () => quillRef?.getText(),
        hasContent: () => (quillRef ? !isEmpty(quillRef) : false),
    }));
    useFTUE(FTUEKeys.IMG2TXT_INTRODUCTION, {
        onFTUE(markComplete) {
            bottomDrawerHelperActions.show({
                component: React.createElement(Img2TxtIntroDrawer, { onConfirm: () => {
                        bottomDrawerHelperActions.hide();
                        markComplete();
                    } }),
            });
        },
    });
    return (React.createElement(Column, { ...columnProps },
        React.createElement(QuillEditor, { onEditorChanged: setQuillRef, readOnly: false, enableCachedImage: false, initialValue: initialValue, initialDelta: initialDelta, placeholder: placeholder, flex: true, gutterBottom: gutterBottom }),
        React.createElement(Toolbar, { quill: quillRef })));
});
export default HTMLEditor;
